<template>
  <div>
    <b-container>
      <b-row class="mt-md-5 ml-md-5">
        <b-col class="mt-2 mt-md-5 ml-md-5">
          <h4>Willkommen beim Standrohrverleihservice der evm.</h4>
        </b-col>
      </b-row>
      <b-row class="ml-md-5">
        <b-col class="mt-5 ml-md-5">
          Bitte geben Sie Ihre Daten ein:
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-4 col-md-6 mt-3 mt-md-2">
          <b-form-group>
            <b-form-radio-group
              id="customer-type"
              v-model="selectedCustType"
              name="customer-type"
              @change="changeType"
            >
              <b-form-radio value="private">Privat</b-form-radio>
              <b-form-radio value="company">Firma</b-form-radio>
              <b-form-radio value="communal">Kommunal</b-form-radio>
              <b-form-invalid-feedback :state="stateSelectedCustType">
                {{msgSelectedCustType}}
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="ml-md-5" v-if="selectedCustType === 'communal'">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="communalno" class="label">Kommunalnummer</label>
          <b-input
            id="communalno"
            ref="communalno"
            type="text"
            v-model="communalno"
            :state="stateCommunalNo"
            aria-describedby="communalno-feedback"
            @keyup.enter="loadCommunal()">
          </b-input>
          <b-form-invalid-feedback id="communalno-feedback">
            {{msgCommunalNo}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <br class="d-none d-sm-block"/>
          <b-button @click="loadCommunal()">Laden</b-button>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="name1" v-if="selectedCustType === 'private' || selectedCustType === ''"
                 class="label">Vorname</label>
          <label for="name1" v-if="selectedCustType !== 'private'" class="label">Firmenname</label>
          <b-input
            id="name1"
            ref="name1"
            type="text"
            :state="stateName1"
            :disabled="selectedCustType === 'communal'"
            v-model="name1"
            aria-describedby="name1-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="name1-feedback">
            {{msgName1}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="name2" v-if="selectedCustType==='private' || selectedCustType===''" class="label">Nachname</label>
          <b-input
            id="name2"
            ref="name2"
            type="text"
            v-model="name2"
            :state="stateName2"
            v-if="selectedCustType==='private' || selectedCustType===''"
            aria-describedby="name2-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="name2-feedback">
            {{msgName2}}
          </b-form-invalid-feedback>

          <label for="contact" v-if="selectedCustType === 'company' || selectedCustType === 'communal'" class="label">Ansprechpartner</label>
          <b-input
            id="contact"
            ref="contact"
            type="text"
            v-model="contact"
            :state="stateContact"
            v-if="selectedCustType === 'company' || selectedCustType === 'communal'"
            aria-describedby="contact-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="contact-feedback">
            {{msgContact}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="ml-md-5" v-if="selectedCustType !== 'communal'">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="street" class="label">Straße</label>
          <b-input
            id="street"
            ref="street"
            type="text"
            v-model="street"
            :state="stateStreet"
            aria-describedby="street-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="street-feedback">
            {{msgStreet}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="houseno" class="label">Hausnummer</label>
          <b-input
            id="houseno"
            ref="houseno"
            type="text"
            v-model="houseNo"
            :state="stateHouseNo"
            aria-describedby="houseNo-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="20">
          </b-input>
          <b-form-invalid-feedback id="houseNo-feedback">
            {{msgHouseNo}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="ml-md-5" v-if="selectedCustType !== 'communal'">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="zip" class="label">Postleitzahl</label>
          <b-input
            id="zip"
            ref="zip"
            type="text"
            v-model="zip"
            :state="stateZip"
            aria-describedby="zip-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="5">
          </b-input>
          <b-form-invalid-feedback id="zip-feedback">
            {{msgZip}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="city" class="label">Ort</label>
          <b-input
            id="city"
            ref="city"
            type="text"
            v-model="city"
            :state="stateCity"
            aria-describedby="city-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="city-feedback">
            {{msgCity}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="mail" class="label">E-Mail-Adresse</label>
          <b-input
            id="mail"
            ref="mail"
            type="text"
            v-model="mail"
            :state="stateMail"
            aria-describedby="mail-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="mail-feedback">
            {{msgMail}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="fon" class="label">Telefon</label>
          <b-input
            id="fon"
            ref="fon"
            type="text"
            v-model="fon"
            :state="stateFon"
            aria-describedby="fon-feedback"
            @keyup.enter="validateAndSave()"
            maxlength="30">
          </b-input>
          <b-form-invalid-feedback id="fon-feedback">
            {{msgFon}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="ml-md-5 mt-3" v-if="msgError">
        <b-col class="ml-md-2 ml-md-5 text-danger">{{msgError}}&nbsp;</b-col>
      </b-row>
      <b-row class="ml-md-5 mt-3">
        <b-col class="col-9 col-md-4 col-lg-3 ml-md-5 mt-3 mt-md-2">
          <div v-if="selectedCustType !== 'communal'">Schritt 1 von 3</div>
          <div v-if="selectedCustType === 'communal'">Schritt 1 von 2</div>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2" >
          <b-container class="no-gutters p-0">
            <b-row class="no-gutters ">
              <b-col class="d-flex flex-row">
                <b-button
                  class="ml-md-auto"
                  @click="reset()"
                >
                  Reset
                </b-button>
              </b-col>
              <b-col class="d-flex flex-row">
                <b-button
                  class="ml-md-auto"
                  @click="validateAndSave()"
                >
                  Weiter
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>&nbsp;</b-col>
      </b-row>
    </b-container>

    <cookie-consent
      message="Unsere Webseite verwendet Cookies. Informationen zu den verwendeten Cookies und weitere datenschutzrechtliche Hinweise finden Sie in unseren"
      linkLabel="Datenschutzhinweisen."
      href="https://www.evm.de/evm/Homepage/Impressum/#datenschutz"
      buttonLabel="Akzeptieren"
    />
  </div>
</template>

<script>

import { ApiCalls } from '@/scripts/ApiCalls'

export default {
  name: 'StandrohrStart',
  components: {},
  data () {
    return {
      selectedCustType: 'private',
      stateSelectedCustType: null,
      msgSelectedCustType: '',
      labelName: 'Vorname',
      communalno: '',
      stateCommunalNo: null,
      msgCommunalNo: '',
      name1: '',
      stateName1: null,
      msgName1: '',
      name2: '',
      stateName2: null,
      msgName2: '',
      contact: '',
      stateContact: null,
      msgContact: '',
      street: '',
      stateStreet: null,
      msgStreet: '',
      houseNo: '',
      stateHouseNo: null,
      msgHouseNo: '',
      zip: '',
      stateZip: null,
      msgZip: '',
      city: '',
      stateCity: null,
      msgCity: '',
      mail: '',
      stateMail: null,
      msgMail: '',
      fon: '',
      stateFon: null,
      msgFon: '',
      msgError: ''
    }
  },
  created () {
    console.log('created: ' + localStorage.customerId)
    if (localStorage.customerId) {
      this.selectedCustType = localStorage.selectedCustType
      this.communalno = localStorage.communalno
      this.name1 = localStorage.name1
      this.name2 = localStorage.name2
      this.contact = localStorage.contact
      this.street = localStorage.street
      this.houseNo = localStorage.houseNo
      this.zip = localStorage.zip
      this.city = localStorage.city
      this.mail = localStorage.mail
      this.fon = localStorage.fon
    }
  },
  methods: {
    reset () {
      localStorage.customerId = ''
      localStorage.selectedCustType = null
      localStorage.communalno = ''
      localStorage.name1 = ''
      localStorage.name2 = ''
      localStorage.contact = ''
      localStorage.street = ''
      localStorage.houseNo = ''
      localStorage.zip = ''
      localStorage.city = ''
      localStorage.mail = ''
      localStorage.fon = ''
      localStorage.useSteet = ''
      localStorage.useHouseNo = ''
      localStorage.useZip = ''
      localStorage.useCity = ''
      localStorage.connectionType = ''
      localStorage.useCase = ''
      localStorage.useUntil = ''
      localStorage.iban = ''
      localStorage.bic = ''
      localStorage.bank = ''
      localStorage.paymentMethod = null
      localStorage.contactType = ''
      localStorage.paymentContact = ''
      localStorage.paymentContactKind = ''

      this.selectedCustType = 'private'
      this.communalno = ''
      this.name1 = ''
      this.name2 = ''
      this.contact = ''
      this.street = ''
      this.houseNo = ''
      this.zip = ''
      this.city = ''
      this.mail = ''
      this.fon = ''
    },
    loadCommunal () {
      this.saveLocal()
      if (!this.communalno) {
        this.msgCommunalNo = 'Bitte Kommunalnummer eingeben.'
        this.stateCommunalNo = false
      } else {
        this.msgCommunalNo = ''
        this.stateCommunalNo = null
        if (!/[\w-]/i.test(this.communalno)) { // TODO Regex anpassen wenn schema vorliegt
          this.msgCommunalNo = 'Keine gültige Kommunalnummer.'
          this.stateCommunalNo = false
        } else {
          this.stateCommunalNo = null
          this.msgCommunalNo = ''
          this.saveLocal()
          ApiCalls.loadSpecialCustomer(this.communalno).then(res => {
            console.log(res)
            if (isNaN(res) && res.startsWith('ERROR')) {
              this.stateCommunalNo = false
              this.msgCommunalNo = 'Keine gültige Kommunalnummer.'
            } else {
              this.name1 = res
            }
          }).catch(error => {
            this.loading = false
            console.log(error)
            this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
          })
        }
      }
    },
    saveLocal () {
      localStorage.selectedCustType = this.selectedCustType
      localStorage.communalno = this.communalno
      localStorage.name1 = this.name1
      localStorage.name2 = this.name2
      localStorage.contact = this.contact
      localStorage.street = this.street
      localStorage.houseNo = this.houseNo
      localStorage.zip = this.zip
      localStorage.city = this.city
      localStorage.mail = this.mail
      localStorage.fon = this.fon
    },
    changeType () {
      this.$nextTick(() => {
        if (this.selectedCustType === 'private') {
          this.communalno = ''
          this.contact = ''
        } else if (this.selectedCustType === 'company') {
          this.communalno = ''
          this.name2 = ''
        } else if (this.selectedCustType === 'communal') {
          this.name1 = ''
          this.name2 = ''
          this.street = ''
          this.houseNo = ''
          this.zip = ''
          this.city = ''
        }
      })
    },
    validateAndSave () {
      let save = true
      if (!this.selectedCustType) {
        this.stateSelectedCustType = false
        this.msgSelectedCustType = 'Bitte eine Option auswählen.'
        save = false
      } else {
        this.stateSelectedCustType = null
        this.msgSelectedCustType = ''
        if (this.selectedCustType === 'private' || this.selectedCustType === 'company') {
          if (!this.name1) {
            if (this.selectedCustType === 'private') {
              this.msgName1 = 'Bitte Vorname eingeben.'
            } else if (this.selectedCustType === 'company') {
              this.msgName1 = 'Bitte Firmenname eingeben.'
            }
            this.stateName1 = false
            save = false
          } else {
            this.msgName1 = ''
            this.stateName1 = null
            if (!/^[\p{L}\w &,.'\-+]+$/u.test(this.name1)) {
              this.msgName1 = 'Der Name enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie ,.+\'-&'
              this.stateName1 = false
              save = false
            }
          }

          if (this.selectedCustType === 'private') {
            this.msgContact = ''
            this.stateContact = null
            if (!this.name2) {
              this.msgName2 = 'Bitte Nachname eingeben.'
              this.stateName2 = false
              save = false
            } else {
              this.msgName2 = ''
              this.stateName2 = null
              if (!/^[\p{L}\w &,.'\-+]+$/u.test(this.name2)) {
                this.msgName2 = 'Der Name enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie ,.+\'-&'
                this.stateName2 = false
                save = false
              }
            }
          }

          if (this.selectedCustType === 'company') {
            this.msgName2 = ''
            this.stateName2 = null
            if (!this.contact) {
              this.msgContact = 'Bitte Ansprechpartner eingeben.'
              this.stateContact = false
              save = false
            } else {
              this.msgContact = ''
              this.stateContact = null
              if (!/^[\p{L}\w &,.'\-+]+$/u.test(this.contact)) {
                this.msgContact = 'Der Ansprechpartner enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie ,.+\'-&'
                this.stateContact = false
                save = false
              }
            }
          }

          if (!this.street) {
            this.msgStreet = 'Bitte Straße eingeben.'
            this.stateStreet = false
            save = false
          } else {
            this.msgStreet = ''
            this.stateStreet = null
            if (!/^[\p{L}\w &.'-]+$/u.test(this.street)) {
              this.msgStreet = 'Sie Straße enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie .-&ß'
              this.stateStreet = false
              save = false
            }
          }

          if (!this.houseNo) {
            this.msgHouseNo = 'Bitte Hausnummer eingeben.'
            this.stateHouseNo = false
            save = false
          } else {
            this.msgHouseNo = ''
            this.stateHouseNo = null
            if (!/^[\w äüöß&.'-]+$/i.test(this.houseNo)) {
              this.msgHouseNo = 'Die Hausnummer enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie .-&'
              this.stateHouseNo = false
              save = false
            }
          }

          if (!this.zip) {
            this.msgZip = 'Bitte Postleizahl eingeben.'
            this.stateZip = false
            save = false
          } else {
            this.msgZip = ''
            this.stateZip = null
            if (!/^[\d]{5}$/.test(this.zip)) {
              this.msgZip = 'Ungültige Postleitzahl. Bitte 5 Zahlen eingeben'
              this.stateZip = false
              save = false
            }
          }

          if (!this.city) {
            this.msgCity = 'Bitte Ort eingeben.'
            this.stateCity = false
            save = false
          } else {
            this.msgCity = ''
            this.stateCity = null
            if (!/^[a-z äüöß&-]+$/i.test(this.city)) {
              this.msgCity = 'Der Ort enthält ungültige Zeichen. Erlaubt sind Buchstaben und -'
              this.stateCity = false
              save = false
            }
          }
        } else if (this.selectedCustType === 'communal') {
          this.msgName2 = ''
          this.stateName2 = null
          if (!this.contact) {
            this.msgContact = 'Bitte Ansprechpartner eingeben.'
            this.stateContact = false
            save = false
          } else {
            this.msgContact = ''
            this.stateContact = null
            if (!/^[\p{L}\w &,.'-+]+$/u.test(this.contact)) {
              this.msgContact = 'Der Ansprechpartner enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie ,.+\'-&'
              this.stateContact = false
              save = false
            }
          }
          if (!this.communalno) {
            this.msgCommunalNo = 'Bitte Kommunalnummer eingeben.'
            this.stateCommunalNo = false
            save = false
          } else {
            this.msgCommunalNo = ''
            this.stateCommunalNo = null
            if (!/^[\w-]+$/i.test(this.communalno)) { // TODO Regex anpassen wenn schema vorliegt
              this.msgCommunalNo = 'Keine gültige Kommunalnummer.'
              this.stateCommunalNo = false
              save = false
            }
          }
        }

        if (!this.mail) {
          this.msgMail = 'Bitte E-Mail-Adresse eingeben.'
          this.stateMail = false
          save = false
        } else {
          this.msgMail = ''
          this.stateMail = null
          // eslint-disable-next-line no-control-regex
          let regexMail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
          // let regexMail = /^[A-Z0-9._%+-]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/
          if (!regexMail.test(this.mail)) {
            this.msgMail = 'Ungültige E-Mail-Adresse'
            this.stateMail = false
            save = false
          }
        }

        if (!this.fon) {
          this.msgFon = 'Bitte Telefonnummer eingeben.'
          this.stateFon = false
          save = false
        } else {
          this.msgFon = ''
          this.stateFon = null
          if (!/^[\d+]{7,30}$/i.test(this.fon)) {
            this.msgFon = 'Ungültige Telefonnummer. Erlaubt sind nur Zahlen und ein +. Mindestens 7 Zahlen. '
            this.stateFon = false
            save = false
          }
        }
      }

      if (save) {
        this.saveLocal()
        ApiCalls.safeFirstForm(localStorage.customerId, this.selectedCustType, this.communalno, this.name1, this.name2,
          this.contact, this.street, this.houseNo, this.zip, this.city, this.mail, this.fon).then(res => {
          console.log(res)
          if (isNaN(res) && res.startsWith('ERROR')) {
            if (res === 'ERROR-COMMUNAL') {
              this.stateCommunalNo = false
              this.msgCommunalNo = 'Keine gültige Kommunalnummer.'
            } else {
              this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
            }
          } else {
            localStorage.customerId = res
            this.$router.replace({ name: 'standrohr-2' })
          }
        }).catch(error => {
          this.loading = false
          console.log(error)
          this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
        })
      }
    }
  }
}
</script>

<style lang="css">

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }

  .btn-evm-orange:hover {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }

  .form-control {
    padding-right: 1px !important;
    padding-left: 5px !important;
  }
</style>

<style lang="scss">
  /*
    CookieConsent
  */
  @import "../../scss/cookie-consent";
  @import "../../scss/cookie-consent-bottom";
  @import "../../scss/cookie-consent-transition";
  /*
    Bootstrap
  */
  @import "~bootstrap/scss/bootstrap";
</style>
